import Vue from 'vue'

export default {
  getDisclosureInformation ({ commit }) {
    return Vue.axios.get(`/about/disclosure-information`)
    .then(({ data }) => commit('ADD_DISCLOSURE_INFORMATION', data))
  },
  addDisclosureInformation ({ commit }, data) {
    commit('ADD_NEW_DISCLOSURE_INFORMATION', data)
  },
  updateDisclosureInformation ({ commit }, doc) {
    commit('UPDATE_DISCLOSURE_INFORMATION', doc)
  },
  deleteDisclosureInformation ({ commit }, id) {
    commit('DELETE_DISCLOSURE_INFORMATION', id)
  },
  loadDisclosureInformationFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/disclosure-information/${id}/change-file`, formData)
  },
  updateAllDisclosureDocuments ({ commit }, documents) {
    commit('ADD_DISCLOSURE_INFORMATION', documents)
  },
  saveDisclosureInformation ({ commit, dispatch }, information) {
    return Vue.axios.put(`/about/disclosure-information`, { information })
    .then(() => {
      return information.filter(d => d.newFile).reduce(
        (p, v) => p.then((a) => dispatch('loadDisclosureInformationFile', { formData: v.newFile, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/disclosureInformation.js